import AppChannel from "../AppChannel";

export default class MenuChannel extends AppChannel {
    addReportItems(items) {
        this.trigger("addReportItems", items);
    }

    renameItem(params) {
        this.trigger("renameItem", params);
    }

    addItem(params) {
        this.trigger("addItem", params);
    }

    removeItem(item) {
        this.trigger("removeItem", item);
    }
}
